import axios from "@/utils/request";

// 手机密码登录
export const loginAccount = (query) => {
    return axios({
        url: "/h5/login/account",
        method: "post",
        data: query,
    });
};

// 获取手机号验证码
export const smsSend = (query) => {
    return axios({
        url: "/h5/login/loginSend",
        method: "post",
        data: query,
    });
};

// 手机短信登录
export const loginSMS = (query) => {
    return axios({
        url: "/h5/login/sms",
        method: "post",
        data: query,
    });
};

// 退出登录
export const userLogOut = (query) => {
    return axios({
        url: "/h5/user/logOut",
        method: "post",
        params: query,
    });
};

// 检测验证码是否正确
export const smsCheckCode = (query) => {
    return axios({
        url: "h5/sms/checkCode",
        method: "post",
        data: query,
    });
};

// 修改登录密码
export const userChangepwd = (query) => {
    return axios({
        url: "/h5/user/changepwd",
        method: "post",
        data: query,
    });
};

// 获取用户权限菜单
export const getAuthMenu = (query) => {
    return axios({
        url: "/pms/menu/getAuthMenu",
        method: "get",
        params: query,
    });
};

// 获取基础设置
export const companyBasics = (query) => {
    return axios({
        url: "/pms/company/basics",
        method: "get",
        params: query,
    });
};
//获取二维码
export const getQrCode = (query) => {
    return axios({
        url: "/h5/login/qrcode",
        method: "get",
        params: query,
    });
};
//检查登录状态
export const checkCode = (query) => {
    return axios({
        url: "/h5/login/checkCode",
        method: "post",
        data: query,
    });
};

// 获取ota账号列表
export const otaAccountList = (query) => {
    return axios({
        url: "/pms/ota/otaAccountList",
        method: "get",
        params: query,
    });
};

// 获取添加的ota渠道账号列表
export const otaGetComOtaList = (query) => {
    return axios({
        url: "/pms/ota/getComOtaList",
        method: "get",
        params: query,
    });
};

// 添加渠道账号列表
export const addOtaAccountList = (query) => {
    return axios({
        url: "/pms/ota/getOtaList",
        method: "get",
        params: query,
    });
};

// OTA列表
export const otaCompanyOta = (query) => {
    return axios({
        url: "/pms/ota/companyOta",
        method: "get",
        params: query,
    });
};

// 删除渠道账号
export const otaDel = (query) => {
    return axios({
        url: "/pms/ota/del",
        method: "post",
        data: query,
    });
};

// 添加渠道账号
export const otaAdd = (query) => {
    return axios({
        url: "/pms/ota/add",
        method: "post",
        data: query,
    });
};
// 编辑账号
export const otaEdit = (query) => {
    return axios({
        url: "/pms/ota/update",
        method: "post",
        data: query,
    });
};
// 账号状态变更
export const otaStatus = (query) => {
    return axios({
        url: "/pms/ota/status",
        method: "post",
        data: query,
    });
};
// 获取宝寓的推送地址
export const otaByCallBackUrl = (query) => {
    return axios({
        url: "/pms/ota/byCallBackUrl",
        method: "post",
        data: query,
    });
};
// 宝寓账号验证
export const otaByCheckAccount = (query) => {
    return axios({
        url: "/pms/ota/byCheckAccount",
        method: "post",
        data: query,
    });
};

// 云掌柜获取城市
export const otaYunZhangGuiGetCityList = (query) => {
    return axios({
        url: "/pms/ota/getYzgCityList",
        method: "get",
        params: query,
    });
};
// 云掌柜注册账号
export const otaYunZhangGuiRegister = (query) => {
    return axios({
        url: "/pms/ota/yzgRigister",
        method: "post",
        data: query,
    });
};
// 云掌柜注册账号
export const otaYunZhangGuiRegisterList = (query) => {
    return axios({
        url: "/pms/ota/yzgRigisterList",
        method: "get",
        params: query,
    });
};

// 异步读取聊天联系人列表
export const otaReadLinkman = (query) => {
    return axios({
        url: "/pms/ota/getUserContactList",
        method: "post",
        data: query,
    });
};

// 读取房源
export const otaSyncRoom = (query) => {
    return axios({
        url: "/pms/ota/syncRoom",
        method: "get",
        params: query,
    });
};
// ota房源管理
export const otaHouse = (query) => {
    return axios({
        url: "/pms/ota/house",
        method: "get",
        params: query,
    });
};

// 关联房源
export const otaHouseRela = (query) => {
    return axios({
        url: "/pms/ota/houseRela",
        method: "post",
        data: query,
    });
};

// 取消关联房间
export const otaDelHouseRela = (query) => {
    return axios({
        url: "/pms/ota/delHouseRela",
        method: "post",
        data: query,
    });
};

// 获取搜索列表
export const getSearchList = (query) => {
    return axios({
        url: "/pms/search/list",
        method: "get",
        params: query,
    });
};

// 订单列表
export const getOrderList = (query) => {
    return axios({
        url: "/pms/order/list",
        method: "get",
        params: query,
    });
};

// 获取房间列表
export const getHouseList = (query) => {
    return axios({
        url: "/pms/house/list",
        method: "get",
        params: query,
    });
};

// 获取分组列表
export const getGroupList = (query) => {
    return axios({
        url: "/pms/group/list",
        method: "get",
        params: query,
    });
};

// 获取房型列表
export const getRoomList = (query) => {
    return axios({
        url: "/pms/room/list",
        method: "get",
        params: query,
    });
};

// 新增房间
export const houseAdd = (query) => {
    return axios({
        url: "/pms/house/add",
        method: "post",
        data: query,
    });
};

// 更新保存房间
export const houseEdit = (query) => {
    return axios({
        url: "/pms/house/edit",
        method: "post",
        data: query,
    });
};

// 获取房间详情
export const houseDetails = (query) => {
    return axios({
        url: "/pms/house/details",
        method: "get",
        params: query,
    });
};

// 删除房间
export const houseDel = (query) => {
    return axios({
        url: "/pms/house/del",
        method: "post",
        data: query,
    });
};

// 获取区域信息
export const getArea = (query) => {
    return axios({
        url: "/h5/getarea",
        method: "post",
        data: query,
    });
};

// 分组列表
export const groupList = (query) => {
    return axios({
        url: "/pms/group/list",
        method: "get",
        params: query,
    });
};

// 添加新分组
export const groupAdd = (query) => {
    return axios({
        url: "/pms/group/add",
        method: "post",
        data: query,
    });
};

// 编辑分组
export const groupEdit = (query) => {
    return axios({
        url: "/pms/group/edit",
        method: "post",
        data: query,
    });
};

// 删除分组
export const groupDel = (query) => {
    return axios({
        url: "/pms/group/del",
        method: "post",
        data: query,
    });
};

// 房型列表
export const roomList = (query) => {
    return axios({
        url: "/pms/room/list",
        method: "get",
        params: query,
    });
};

// 添加房型
export const roomAdd = (query) => {
    return axios({
        url: "/pms/room/add",
        method: "post",
        data: query,
    });
};

// 删除房型
export const roomDel = (query) => {
    return axios({
        url: "/pms/room/del",
        method: "post",
        data: query,
    });
};

// 更新保存房型
export const roomEdit = (query) => {
    return axios({
        url: "/pms/room/edit",
        method: "post",
        data: query,
    });
};

// 确认订单(接单)
export const confirmOrder = (query) => {
    return axios({
        url: "/pms/order/receiving",
        method: "post",
        data: query,
    });
};

// 取消订单
export const cancelOrder = (query) => {
    return axios({
        url: "/pms/order/cancel",
        method: "post",
        data: query,
    });
};

// 添加订单查看房间列表
export const getStockRoomList = (query) => {
    return axios({
        url: "/pms/house/stockList",
        method: "get",
        params: query,
    });
};

// 添加订单
export const addOrder = (query) => {
    return axios({
        url: "/pms/order/add",
        method: "post",
        data: query,
    });
};

// 换房或者分配房间
export const changeRoom = (query) => {
    return axios({
        url: "/pms/order/branchHouse",
        method: "post",
        data: query,
    });
};

// 经营数据
export const operateList = (query) => {
    return axios({
        url: "/pms/operate/list",
        method: "get",
        params: query,
    });
};

// 渠道经营数据
export const operateChannelList = (query) => {
    return axios({
        url: "pms/operate/channelList",
        method: "get",
        params: query,
    });
};

// 获取收支明细
export const costAlllist = (query) => {
    return axios({
        url: "/pms/cost/alllist",
        method: "get",
        params: query,
    });
};

// 删除收支明细
export const costDel = (query) => {
    return axios({
        url: "/pms/cost/del",
        method: "post",
        data: query,
    });
};

// 获取收支结构
export const costStructure = (query) => {
    return axios({
        url: "/pms/cost/structure",
        method: "get",
        params: query,
    });
};

// 订单详情
export const getOrderDetail = (query) => {
    return axios({
        url: "/pms/order/details",
        method: "get",
        params: query,
    });
};

// 添加标签
export const addTag = (query) => {
    return axios({
        url: "/pms/order/addTag",
        method: "post",
        data: query,
    });
};

// 保存费用（记账）
export const addCost = (query) => {
    return axios({
        url: "/pms/cost/add",
        method: "post",
        data: query,
    });
};
//修改费用
export const editCost = (query) => {
    return axios({
        url: "/pms/cost/edit",
        method: "post",
        data: query,
    });
};
//修改费用
export const detailsCost = (query) => {
    return axios({
        url: "/pms/cost/details",
        method: "get",
        params: query,
    });
};
//修改费用
export const verifyCost = (query) => {
    return axios({
        url: "/pms/cost/verify",
        method: "post",
        data: query,
    });
};
//更新结算时间
export const updateSettleTimeCost = (query) => {
    return axios({
        url: "/pms/cost/updateSettleTime",
        method: "get",
        params: query,
    });
};
// 添加订单备注信息
export const editHotelRemark = (query) => {
    return axios({
        url: "/pms/order/companyRemark",
        method: "post",
        data: query,
    });
};
// 编辑订单信息
export const pmsOrderEdit = (query) => {
    return axios({
        url: "/pms/order/orderEdit",
        method: "post",
        data: query,
    });
};
// 发送入住短信
export const pmsOrderSendSms = (query) => {
    return axios({
        url: "/pms/order/sendSms",
        method: "post",
        data: query,
    });
};


// 房价
export const getRoomPrice = (query) => {
    return axios({
        url: "/pms/houseStatus/getPrice",
        method: "get",
        params: query,
    });
};

// 更新房间日历价
export const editHousePrice = (query) => {
    return axios({
        url: "/pms/house/updatecalenderprice",
        method: "post",
        data: query,
    });
};

// 房价中修改价格
export const housePirceEdit = (query) => {
    return axios({
        url: "/pms/houseStatus/houseDailyPrice",
        method: "post",
        data: query,
    });
};

// 房价中修改状态
export const houseStatusEdit = (query) => {
    return axios({
        url: "/pms/houseStatus/updateHouseStatus",
        method: "post",
        data: query,
    });
};

// 获取房间日历价
export const getHouseCalendar = (query) => {
    return axios({
        url: "/pms/house/getcalendarprice",
        method: "post",
        data: query,
    });
};

// 获取日历
export const getDateCalendar = (query) => {
    return axios({
        url: "/pms/house/calender",
        method: "post",
        data: query,
    });
};

// 获取节假日
export const getHolidayDate = (query) => {
    return axios({
        url: "/pms/house/getHolidayList",
        method: "get",
        params: query,
    });
};

// 获取任务列表
export const taskList = (query) => {
    return axios({
        url: "pms/task/taskList",
        method: "get",
        params: query,
    });
};

// 批量更新房间日历价
export const editBathsPrice = (query) => {
    return axios({
        url: "/pms/house/updateBatchPrice",
        method: "post",
        data: query,
    });
};

// 成员列表
export const taskMemberList = (query) => {
    return axios({
        url: "pms/task/memberList",
        method: "get",
        params: query,
    });
};

// 绑定管理员生成公众号二维码
export const taskGenerateMemberQr = (query) => {
    return axios({
        url: "pms/task/generateMemberQr",
        method: "post",
        data: query,
    });
};

// 停用启用某个成员
export const taskEditStatus = (query) => {
    return axios({
        url: "pms/task/editStatus",
        method: "post",
        data: query,
    });
};

// 删除成员
export const taskDelMember = (query) => {
    return axios({
        url: "pms/task/delMember",
        method: "post",
        data: query,
    });
};

// 保洁费列表
export const taskCleanFeeList = (query) => {
    return axios({
        url: "pms/task/cleanFeeList",
        method: "get",
        params: query,
    });
};

// 保存某个房间的保洁费
export const taskSaveCleanFee = (query) => {
    return axios({
        url: "pms/task/saveCleanFee",
        method: "post",
        data: query,
    });
};

// 创建任务
export const taskAdd = (query) => {
    return axios({
        url: "pms/task/add",
        method: "post",
        data: query,
    });
};

// 修改任务
export const taskEdit = (query) => {
    return axios({
        url: "pms/task/edit",
        method: "post",
        data: query,
    });
};

// 删除任务
export const taskDel = (query) => {
    return axios({
        url: "pms/task/del",
        method: "post",
        data: query,
    });
};

// 取消任务
export const taskCancel = (query) => {
    return axios({
        url: "pms/task/cancel",
        method: "post",
        data: query,
    });
};

// 任务详情
export const taskDetails = (query) => {
    return axios({
        url: "pms/task/details",
        method: "get",
        params: query,
    });
};

// 添加成员
export const taskAddMember = (query) => {
    return axios({
        url: "pms/task/addMember",
        method: "post",
        data: query,
    });
};

// 添加成员
export const taskEditMember = (query) => {
    return axios({
        url: "pms/task/editMember",
        method: "post",
        data: query,
    });
};

// 任务统计_按时间
export const taskStatToDate = (query) => {
    return axios({
        url: "pms/task/statToDate",
        method: "get",
        params: query,
    });
};

// 任务统计_按人员
export const taskTaskMeter = (query) => {
    return axios({
        url: "pms/task/taskMeter",
        method: "get",
        params: query,
    });
};

// 任务统计_按房间
export const taskStatToHouse = (query) => {
    return axios({
        url: "pms/task/statToHouse",
        method: "get",
        params: query,
    });
};

// 关闭房间
export const closeHouse = (query) => {
    return axios({
        url: "/pms/house/closeHouse",
        method: "post",
        data: query,
    });
};

// 打开房间
export const openHouse = (query) => {
    return axios({
        url: "/pms/house/openHouse",
        method: "post",
        data: query,
    });
};
// 查看任务日历
export const taskCalendar = (query) => {
    return axios({
        url: "pms/task/calendar",
        method: "get",
        params: query,
    });
};

// 退房
export const checkOutRomm = (query) => {
    return axios({
        url: "/pms/order/checkout",
        method: "post",
        data: query,
    });
};

// 获取房态日历
export const HouseStatusCale = (query) => {
    return axios({
        url: "/pms/HouseStatus/getCale",
        method: "get",
        params: query,
    });
};

// 房间房价日历——房间
export const HousePriceCale = (query) => {
    return axios({
        url: "/pms/house/getcalendarprice",
        method: "post",
        data: query,
    });
};

// 添加租客
export const addTenant = (query) => {
    return axios({
        url: "/pms/tenant/add",
        method: "post",
        data: query,
    });
};

// 编辑租客信息
export const editTenant = (query) => {
    return axios({
        url: "/pms/tenant/edit",
        method: "post",
        data: query,
    });
};

// 编辑租客信息
export const delTenant = (query) => {
    return axios({
        url: "/pms/tenant/del",
        method: "post",
        data: query,
    });
};

// 获取盒子订单列表
export const getOrderBox = (query) => {
    return axios({
        url: "/pms/order/getBoxOrder",
        method: "get",
        params: query,
    });
};
// 获取入住指南设置
export const houseGetGuideInfo = (query) => {
    return axios({
        url: "/pms/guide/getGuideInfo",
        method: "get",
        params: query,
    });
};

// 保存入住指南设置
export const houseSaveGuideInfo = (query) => {
    return axios({
        url: "/pms/guide/add",
        method: "post",
        data: query,
    });
};

// 房型房价
export const roomGetcalendarprice = (query) => {
    return axios({
        url: "/pms/room/getcalendarprice",
        method: "post",
        data: query,
    });
};

// 盒子订单分房
export const orderBoxCheckRoom = (query) => {
    return axios({
        url: "/pms/order/branchBoxOrder",
        method: "post",
        data: query,
    });
};

// 拒绝退款
export const refuseFund = (query) => {
    return axios({
        url: "/pms/order/refuseRefund",
        method: "post",
        data: query,
    });
};

// 同意退款
export const agreefund = (query) => {
    return axios({
        url: "/pms/order/agreeRefund",
        method: "post",
        data: query,
    });
};

// 获取房间列表 1关联的房间2未关联的房间
export const relationHouse = (query) => {
    return axios({
        url: "/pms/room/relationHouse",
        method: "get",
        params: query,
    });
};
// 房型取消关联房间
export const roomCancel = (query) => {
    return axios({
        url: "/pms/room/cancel",
        method: "get",
        params: query,
    });
};

// 获取某天新单入住退房订单
export const getTaskData = (query) => {
    return axios({
        url: "/pms/order/getDayOrder",
        method: "get",
        params: query,
    });
};

// 获取渠道账号以及渠道下账号
export const getOtaAccountList = (query) => {
    return axios({
        url: "/pms/ota/getOtaAccountList",
        method: "get",
        params: query,
    });
};

// 移到盒子订单
export const moveBoxOrder = (query) => {
    return axios({
        url: "/pms/order/moveBoxOrder",
        method: "post",
        data: query,
    });
};

// 获取渠道下某个账号所有同步的房源
export const getOtaComHouseList = (query) => {
    return axios({
        url: "/pms/ota/getOtaComHouseList",
        method: "get",
        params: query,
    });
};

// 获取pms下所有的房源以及渠道下账号关联
export const otagetHouseList = (query) => {
    return axios({
        url: "/pms/ota/getHouseList",
        method: "get",
        params: query,
    });
};

// 获取房型详情
export const getRoomDetails = (query) => {
    return axios({
        url: "/pms/room/details",
        method: "get",
        params: query,
    });
};

// 房间绑定房型
export const houseRelation = (query) => {
    return axios({
        url: "/pms/house/relation",
        method: "get",
        params: query,
    });
};

// 门锁列表
export const lockList = (query) => {
    return axios({
        url: "/pms/lock/list",
        method: "get",
        params: query,
    });
};

// 获取未绑定的房间列表
export const houselockList = (query) => {
    return axios({
        url: "/pms/house/lockList",
        method: "get",
        params: query,
    });
};

// 门锁绑定
export const device_bind = (query) => {
    return axios({
        url: "pms/lock/device_bind",
        method: "post",
        data: query,
    });
};
// 获取锁用户员的信息
export const lockUserInfo = (query) => {
    return axios({
        url: "pms/lock/user_info",
        method: "get",
        params: query,
    });
};

// 门锁重置密码
export const lockUpdatePassword = (query) => {
    return axios({
        url: "pms/lock/update_password",
        method: "post",
        data: query,
    });
};

// 门锁解绑
export const lockDeviceUnbind = (query) => {
    return axios({
        url: "pms/lock/device_unbind",
        method: "post",
        data: query,
    });
};

// 房价头部
export const getHeadList = (query) => {
    return axios({
        url: "/pms/houseStatus/getHeadList",
        method: "get",
        params: query,
    });
};

// 获取锁的设备参数
export const lockGetConfig = (query) => {
    return axios({
        url: "pms/lock/get_server_config",
        method: "get",
        params: query,
    });
};

// 门锁解绑
export const lockSetConfig = (query) => {
    return axios({
        url: "pms/lock/set_server_config",
        method: "post",
        data: query,
    });
};

// 门锁恢复出厂设置
export const lockFactoryConfig = (query) => {
    return axios({
        url: "pms/lock/factory_server_config",
        method: "post",
        data: query,
    });
};

// 门锁开门时长设置
export const setDoorOpenKeepTime = (query) => {
    return axios({
        url: "pms/lock/set_door_open_keep_time",
        method: "post",
        data: query,
    });
};

// 获取锁的设备参数
export const lockDetails = (query) => {
    return axios({
        url: "/pms/lock/details",
        method: "get",
        params: query,
    });
};

// 获取开门记录
export const houseOpenlist = (query) => {
    return axios({
        url: "/pms/house/openlist",
        method: "get",
        params: query,
    });
};
// 获取房间选择列表
export const houseSelectList = (query) => {
    return axios({
        url: "/pms/house/getSelectHouseList",
        method: "get",
        params: query,
    });
};
// 获取pms下所有的房源以及房源下关联的所有渠道账号
export const getHouseShutOtaCom = (query) => {
    return axios({
        url: "/pms/ota/getHouseShutOtaCom",
        method: "get",
        params: query,
    });
};

// 获取pms下所有的房源以及房源下关联的所有渠道账号
export const getRoomShutOtaCom = (query) => {
    return axios({
        url: "/pms/ota/getRoomShutOtaCom",
        method: "get",
        params: query,
    });
};


// 房型渠道关联获取pms下所有的房源以及渠道下账号关联
export const otagetRoomList = (query) => {
    return axios({
        url: "/pms/ota/getRoomList",
        method: "get",
        params: query,
    });
};

// 房间获取pms某个房间的与渠道账号下的房间
export const otaGetOtaHouseList = (query) => {
    return axios({
        url: "/pms/ota/getHouseOtaCom",
        method: "get",
        params: query,
    });
};

// 房型获取pms某个房型的与渠道账号下的房间
export const otaGetOtaRoomList = (query) => {
    return axios({
        url: "/pms/ota/getRoomOtaCom",
        method: "get",
        params: query,
    });
};

// 查询渠道账号
export const otaGetRelatOtaCom = (query) => {
    return axios({
        url: "/pms/ota/getRelatOtaCom",
        method: "get",
        params: query,
    });
};

// 获取所有渠道列表
export const otaGetAllOtaList = (query) => {
    return axios({
        url: "/pms/ota/getAllOtaList",
        method: "get",
        params: query,
    });
};

// 房价详情
export const getDetailsPrice = (query) => {
    return axios({
        url: "/pms/houseStatus/getDetailsPrice",
        method: "get",
        params: query,
    });
};

// 编辑房客入住时间
export const tenantCheckin = (query) => {
    return axios({
        url: "/pms/tenant/checkin",
        method: "post",
        data: query,
    });
};

// 编辑房客退房时间
export const tenantCheckout = (query) => {
    return axios({
        url: "/pms/tenant/checkout",
        method: "post",
        data: query,
    });
};

// 订单确定入住
export const orderConfirmIn = (query) => {
    return axios({
        url: "/pms/order/confirmIn",
        method: "post",
        data: query,
    });
};

// 订单取消订单
export const orderCancel = (query) => {
    return axios({
        url: "/pms/order/cancel",
        method: "post",
        data: query,
    });
};

// 订单确认订单
export const orderReceiving = (query) => {
    return axios({
        url: "/pms/order/receiving",
        method: "post",
        data: query,
    });
};

// 订单确认订单
export const orderCheckout = (query) => {
    return axios({
        url: "/pms/order/checkout",
        method: "post",
        data: query,
    });
};

// 房价日历——ota
export const otaGetCale = (query) => {
    return axios({
        url: "/pms/ota/getCale",
        method: "get",
        params: query,
    });
};

// 订单撤销入住
export const orderRevokeCheckin = (query) => {
    return axios({
        url: "/pms/order/revokeCheckin",
        method: "post",
        data: query,
    });
};

// 获取订单二维码
export const orderGetOrderQrcode = (query) => {
    return axios({
        url: "/pms/order/getOrderQrcode",
        method: "post",
        data: query,
    });
};

// 修改入住配置
export const saveCheckInConfig = (query) => {
    return axios({
        url: "/pms/order/saveCheckInConfig",
        method: "post",
        data: query,
    });
};

// 分享入住指南小程序码
export const getGuideMiniQr = (query) => {
    return axios({
        url: "/pms/order/getGuideMiniQr",
        method: "post",
        data: query,
    });
};
//
export const getMiniAppid = (query) => {
    return axios({
        url: "/h5/MiniQrShare/getAppid",
        method: "post",
        data: query,
    });
};
// 获取身份证正面照片信息
export const getIdcardInfo = (query) => {
    return axios({
        url: "/pms/tenant/idcardOcr",
        method: "post",
        data: query,
    });
};

// 住客信息详情
export const getTenantDet = (query) => {
    return axios({
        url: "/pms/tenant/details",
        method: "get",
        params: query,
    });
};

// 续住
export const stayoverConfirm = (query) => {
    return axios({
        url: "/pms/order/overstay",
        method: "post",
        data: query,
    });
};

// 押金列表
export const orderDepositList = (query) => {
    return axios({
        url: "/pms/order/orderDepositList",
        method: "get",
        params: query,
    });
};

// 押金退款
export const orderDepositRefund = (query) => {
    return axios({
        url: "/pms/order/orderDepositRefund",
        method: "post",
        data: query,
    });
};

// 押金修改
export const orderDepositEdit = (query) => {
    return axios({
        url: "/pms/order/orderDepositEdit",
        method: "post",
        data: query,
    });
};

// 日期备忘
export const updateDayRemark = (query) => {
    return axios({
        url: "/pms/houseStatus/updateDayRemark",
        method: "post",
        data: query,
    });
};

// 获取日期备忘
export const getDayRemark = (query) => {
    return axios({
        url: "/pms/houseStatus/getDayRemark",
        method: "get",
        params: query,
    });
};

// 获取订单日志列表
export const getOrderLogList = (query) => {
    return axios({
        url: "/pms/orderLog/list",
        method: "get",
        params: query,
    });
};
// 订单颜色标记
export const orderSaveColor = (query) => {
    return axios({
        url: "/pms/order/saveColor",
        method: "post",
        data: query,
    });
};

// 保洁配置
export const taskGetConfig = (query) => {
    return axios({
        url: "/pms/task/getConfig",
        method: "get",
        params: query,
    });
};

// 保存保洁配置
export const taskSaveConfig = (query) => {
    return axios({
        url: "/pms/task/saveConfig",
        method: "post",
        data: query,
    });
};

// 保存基础设置
export const companyEdit = (query) => {
    return axios({
        url: "/pms/company/edit",
        method: "post",
        data: query,
    });
};

// 订单来源
export const sourceList = (query) => {
    return axios({
        url: "/pms/source/list",
        method: "get",
        params: query,
    });
};

// 修改自定义来源
export const sourceEdit = (query) => {
    return axios({
        url: "/pms/source/edit",
        method: "post",
        data: query,
    });
};

// 添加自定义来源
export const sourceAdd = (query) => {
    return axios({
        url: "/pms/source/add",
        method: "post",
        data: query,
    });
};

// 删除自定义来源
export const sourceDel = (query) => {
    return axios({
        url: "/pms/source/del",
        method: "post",
        data: query,
    });
};

// 颜色标记列表
export const colorList = (query) => {
    return axios({
        url: "/pms/color/list",
        method: "get",
        params: query,
    });
};

// 修改颜色标记
export const colorEdit = (query) => {
    return axios({
        url: "/pms/color/edit",
        method: "post",
        data: query,
    });
};

// 添加颜色标记
export const colorAdd = (query) => {
    return axios({
        url: "/pms/color/add",
        method: "post",
        data: query,
    });
};

// 删除颜色标记
export const colorDel = (query) => {
    return axios({
        url: "/pms/color/del",
        method: "post",
        data: query,
    });
};

// 交易方式列表
export const paytypeList = (query) => {
    return axios({
        url: "/pms/paytype/list",
        method: "get",
        params: query,
    });
};

// 修改交易方式
export const paytypeEdit = (query) => {
    return axios({
        url: "/pms/paytype/edit",
        method: "post",
        data: query,
    });
};

// 添加交易方式
export const paytypeAdd = (query) => {
    return axios({
        url: "/pms/paytype/add",
        method: "post",
        data: query,
    });
};

// 删除交易方式
export const paytypeDel = (query) => {
    return axios({
        url: "/pms/paytype/del",
        method: "post",
        data: query,
    });
};

// 标签列表
export const tagList = (query) => {
    return axios({
        url: "/pms/tag/list",
        method: "get",
        params: query,
    });
};

// 修改标签
export const tagEdit = (query) => {
    return axios({
        url: "/pms/tag/edit",
        method: "post",
        data: query,
    });
};

// 添加标签
export const tagAdd = (query) => {
    return axios({
        url: "/pms/tag/add",
        method: "post",
        data: query,
    });
};

// 删除标签
export const tagDel = (query) => {
    return axios({
        url: "/pms/tag/del",
        method: "post",
        data: query,
    });
};

// 收入项目列表
export const inoutList = (query) => {
    return axios({
        url: "/pms/inout/list",
        method: "get",
        params: query,
    });
};

// 修改收入项目
export const inoutEdit = (query) => {
    return axios({
        url: "/pms/inout/edit",
        method: "post",
        data: query,
    });
};

// 添加收入项目
export const inoutAdd = (query) => {
    return axios({
        url: "/pms/inout/add",
        method: "post",
        data: query,
    });
};

// 删除收入项目
export const inoutDel = (query) => {
    return axios({
        url: "/pms/inout/del",
        method: "post",
        data: query,
    });
};

// 客服详情
export const customerDetails = (query) => {
    return axios({
        url: "/pms/customer/details",
        method: "get",
        params: query,
    });
};

// 修改客服
export const customerSaveData = (query) => {
    return axios({
        url: "/pms/customer/saveData",
        method: "post",
        data: query,
    });
};

// 服务单
export const OrderServiceList = (query) => {
    return axios({
        url: "/pms/OrderService/list",
        method: "get",
        params: query,
    });
};

// 取消服务
export const OrderServiceCancel = (query) => {
    return axios({
        url: "/pms/OrderService/cancel",
        method: "post",
        data: query,
    });
};

// 修改服务状态
export const OrderServiceUpdateStatus = (query) => {
    return axios({
        url: "/pms/OrderService/updateStatus",
        method: "post",
        data: query,
    });
};

// 客房服务列表
export const serviceList = (query) => {
    return axios({
        url: "/pms/service/list",
        method: "get",
        params: query,
    });
};

// 添加客房服务
export const serviceAdd = (query) => {
    return axios({
        url: "/pms/service/add",
        method: "post",
        data: query,
    });
};

// 修改客房服务
export const serviceEdit = (query) => {
    return axios({
        url: "/pms/service/edit",
        method: "post",
        data: query,
    });
};

// 删除客房服务
export const serviceDel = (query) => {
    return axios({
        url: "/pms/service/del",
        method: "post",
        data: query,
    });
};

// 房态新接口
export const HouseStatusgetListNew = (query) => {
    return axios({
        url: "/pms/HouseStatus/getListNew",
        method: "get",
        params: query,
    });
};

// 门店管理列表
export const storeList = (query) => {
    return axios({
        url: "/pms/store/list",
        method: "get",
        params: query,
    });
};

// 添加门店
export const storeAdd = (query) => {
    return axios({
        url: "/pms/store/add",
        method: "post",
        data: query,
    });
};
// 编辑门店
export const storeEdit = (query) => {
    return axios({
        url: "/pms/store/edit",
        method: "post",
        data: query,
    });
};
// 门店详情
export const storeDetails = (query) => {
    return axios({
        url: "/pms/store/details",
        method: "get",
        params: query,
    });
};
// 删除门店
export const storeDel = (query) => {
    return axios({
        url: "/pms/store/del",
        method: "post",
        data: query,
    });
};
// 修改订单
export const orderEdit = (query) => {
    return axios({
        url: "/pms/order/edit",
        method: "post",
        data: query,
    });
};
// 江苏省上报统计列表
export const reportStatJsList = (query) => {
    return axios({
        url: "/pms/jiangSuSheng/list",
        method: "get",
        params: query,
    });
};
// 江苏省刷新最新数据统计
export const reportStatJsUpdateDatas = (query) => {
    return axios({
        url: "/pms/jiangSuSheng/updateDatas",
        method: "post",
        data: query,
    });
};
// 江苏省经营者列表
export const reportStatJsOperator = (query) => {
    return axios({
        url: "/pms/jiangSuSheng/operator",
        method: "get",
        params: query,
    });
};
// 江苏省房源列表
export const reportStatJsHouse = (query) => {
    return axios({
        url: "/pms/jiangSuSheng/house",
        method: "get",
        params: query,
    });
};
// 江苏省门锁安装
export const reportStatJsLock = (query) => {
    return axios({
        url: "/pms/jiangSuSheng/lock",
        method: "get",
        params: query,
    });
};
// 江苏省门锁安装
export const reportStatJsCheckIn = (query) => {
    return axios({
        url: "/pms/jiangSuSheng/checkIn",
        method: "get",
        params: query,
    });
};
// 江苏省门锁安装
export const reportStatJsTenant = (query) => {
    return axios({
        url: "/pms/jiangSuSheng/tenant",
        method: "get",
        params: query,
    });
};
// 江苏省门锁安装
export const reportStatJsOpenDoor = (query) => {
    return axios({
        url: "/pms/jiangSuSheng/openDoor",
        method: "get",
        params: query,
    });
};
// 订单换房
export const orderChangeRoom = (query) => {
    return axios({
        url: "/pms/order/changeRoom",
        method: "post",
        data: query,
    });
};
// 撤销退房
export const orderRevokeCheckOut = (query) => {
    return axios({
        url: "/pms/order/revokeCheckOut",
        method: "post",
        data: query,
    });
};
// 订单获取租客列表
export const orderTenantList = (query) => {
    return axios({
        url: "/pms/tenant/orderList",
        method: "get",
        params: query,
    });
};
// 国泰经营者列表
export const guotaiOperatorList = (query) => {
    return axios({
        url: "/pms/guotai/operatorList",
        method: "get",
        params: query,
    });
};
// 国泰经营者详情
export const guotaiOperatorDetail = (query) => {
    return axios({
        url: "/pms/guotai/operatorDetail",
        method: "get",
        params: query,
    });
};
// 编辑经营者信息
export const guotaiOperatorEdit = (query) => {
    return axios({
        url: "/pms/guotai/operatorEdit",
        method: "post",
        data: query,
    });
};
// 国泰房间列表
export const guotaiOperatorSyn = (query) => {
    return axios({
        url: "/pms/guotai/operatorSyn",
        method: "post",
        data: query,
    });
};
// 国泰房间列表
export const guotaiOperatorDel = (query) => {
    return axios({
        url: "/pms/guotai/operatorDel",
        method: "post",
        data: query,
    });
};

// 获取派出所信息
export const getStationList = (query) => {
    return axios({
        url: "/pms/guotai/getStationList",
        method: "get",
        params: query,
    });
};
// 获取国泰选项信息
export const getSelectList = (query) => {
    return axios({
        url: "/pms/guotai/getSelect",
        method: "get",
        params: query,
    });
};
// 国泰房间列表
export const guotaiHouseList = (query) => {
    return axios({
        url: "/pms/guotai/houseList",
        method: "get",
        params: query,
    });
};
// 国泰房间编辑
export const guotaiHouseEdit = (query) => {
    return axios({
        url: "/pms/guotai/houseEdit",
        method: "post",
        data: query,
    });
};
// 国泰房间状态变更
export const guotaiHouseStatus = (query) => {
    return axios({
        url: "/pms/guotai/houseStatus",
        method: "post",
        data: query,
    });
};
// 国泰房间状态变更
export const guotaiHouseSyn = (query) => {
    return axios({
        url: "/pms/guotai/houseSyn",
        method: "post",
        data: query,
    });
};
// 合并订单
export const mergeOrder = (query) => {
    return axios({
        url: "/pms/order/mergeOrder",
        method: "post",
        data: query,
    });
};
// 意见与建议列表
export const feedBackList = (query) => {
    return axios({
        url: "/pms/feedback/list",
        method: "get",
        params: query,
    });
};
// 意见与建议详情
export const feedBackDetails = (query) => {
    return axios({
        url: "/pms/feedback/details",
        method: "get",
        params: query,
    });
};
// 意见与建议操作
export const feedBackOperate = (query) => {
    return axios({
        url: "/pms/feedback/operate",
        method: "post",
        data: query,
    });
};
// 开票列表
export const invoiceList = (query) => {
    return axios({
        url: "/pms/invoice/list",
        method: "get",
        params: query,
    });
};
// 开票操作
export const invoiceOperate = (query) => {
    return axios({
        url: "/pms/invoice/operate",
        method: "post",
        data: query,
    });
};
// 黑名单列表
export const blackList = (query) => {
    return axios({
        url: "/pms/black/list",
        method: "get",
        params: query,
    });
};
// 黑名单添加
export const blackAdd = (query) => {
    return axios({
        url: "/pms/black/add",
        method: "post",
        data: query,
    });
};
// 黑名单添加
export const blackEdit = (query) => {
    return axios({
        url: "/pms/black/edit",
        method: "post",
        data: query,
    });
};
// 黑名单添加
export const blackDel = (query) => {
    return axios({
        url: "/pms/black/del",
        method: "post",
        data: query,
    });
};
// 入住使用列表
export const tenantList = (query) => {
    return axios({
        url: "/pms/tenant/tenantList",
        method: "get",
        params: query,
    });
};

// 苏州市网约房入住登记
export const guotaiOrder = (query) => {
    return axios({
        url: "/pms/guotai/order",
        method: "get",
        params: query,
    });
};
// 苏州市网约房入住登记
export const guotaiCheckIn = (query) => {
    return axios({
        url: "/pms/guotai/checkIn",
        method: "get",
        params: query,
    });
};
// 苏州市网约房退房记录
export const guotaiCheckOut = (query) => {
    return axios({
        url: "/pms/guotai/checkOut",
        method: "get",
        params: query,
    });
};
// 苏州市网约房开门记录
export const guotaiOpenDoor = (query) => {
    return axios({
        url: "/pms/guotai/openDoor",
        method: "get",
        params: query,
    });
};


// 江苏常州-经营者列表
export const ChangZhouOperatorList = (query) => {
    return axios({
        url: "/pms/changzhou/operator/list",
        method: "get",
        params: query,
    });
};
// 江苏常州-经营者详情
export const ChangZhouOperatorDetail = (query) => {
    return axios({
        url: "/pms/changzhou/operator/detail",
        method: "get",
        params: query,
    });
};
// 江苏常州-经营者编辑
export const ChangZhouOperatorEdit = (query) => {
    return axios({
        url: "/pms/changzhou/operator/edit",
        method: "post",
        data: query,
    });
};
// 江苏常州-经营者同步
export const ChangZhouOperatorSyn = (query) => {
    return axios({
        url: "/pms/changzhou/operator/syn",
        method: "post",
        data: query,
    });
};
// 江苏常州-经营者状态变更
export const ChangZhouOperatorStatus = (query) => {
    return axios({
        url: "/pms/changzhou/operator/status",
        method: "post",
        data: query,
    });
};
// 江苏常州-房源列表
export const ChangZhouHouseList = (query) => {
    return axios({
        url: "/pms/changzhou/house/list",
        method: "get",
        params: query,
    });
};
// 江苏常州-房源详情
export const ChangZhouHouseDetail = (query) => {
    return axios({
        url: "/pms/changzhou/house/detail",
        method: "get",
        params: query,
    });
};
// 江苏常州-房源编辑
export const ChangZhouHouseEdit = (query) => {
    return axios({
        url: "/pms/changzhou/house/edit",
        method: "post",
        data: query,
    });
};
// 江苏常州-房源同步
export const ChangZhouHouseSyn = (query) => {
    return axios({
        url: "/pms/changzhou/house/syn",
        method: "post",
        data: query,
    });
};
// 江苏常州-订单
export const ChangZhouOrderList = (query) => {
    return axios({
        url: "/pms/changzhou/order/list",
        method: "get",
        params: query,
    });
};
// 江苏常州-入住登记
export const ChangZhouCheckIn = (query) => {
    return axios({
        url: "/pms/changzhou/order/checkin",
        method: "get",
        params: query,
    });
};
// 江苏常州-订单
export const ChangZhouOpen = (query) => {
    return axios({
        url: "/pms/changzhou/order/open",
        method: "get",
        params: query,
    });
};

//点点人头-获取设备列表
export const GetDeviceList = (query) => {
    return axios({
        url: "/pms/dianDianRenTou/deviceList",
        method: "post",
        data: query,
    });
};

//点点人头-获取设备详情信息
export const GetDeviceInfo = (query) => {
    return axios({
        url: "/pms/dianDianRenTou/deviceInfo",
        method: "post",
        data: query,
    });
};

//点点人头-获取图片地址
export const GetImage = (query) => {
    return axios({
        url: "/pms/dianDianRenTou/getFileImage",
        method: "get",
        params: query,
    });
};

//点点人头-日志查询
export const GetLogList = (query) => {
    return axios({
        url: "/pms/dianDianRenTouPull/logList",
        method: "get",
        params: query,
    });
};

// 再次申请退款
export const orderDepositRefundAgain = (query) => {
    return axios({
        url: "/pms/orderDeposit/refundAgain",
        method: "post",
        data: query,
    });
};

//查询微信支付状态
export const queryDepositPayStatus = (query) => {
    return axios({
        url: "/pms/order/queryDepositPayStatus",
        method: "post",
        data: query,
    });
};

// 获取公司配置
export const getCompanyConfig = (query) => {
    return axios({
        url: "/pms/Company/getHouseExpire",
        method: "get",
        params: query,
    });
};
